import React from "react";
import classNames from "classnames";
import styles from "./Radio.module.scss";
export const Radio = (props) => {
    var _a;
    const size = (_a = props.size) !== null && _a !== void 0 ? _a : 20;
    const changeHandler = () => {
        var _a;
        if (!props.disabled) {
            (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props);
        }
    };
    return (React.createElement("div", { className: classNames("radio", styles.Wrapper, {
            [styles.IsDisabled]: props.disabled,
            [styles.IsChecked]: props.checked,
        }), style: { width: size, height: size }, onClick: changeHandler, "data-testid": props["data-testid"], role: "radio" }, props.checked && React.createElement("div", { className: styles.Checked })));
};
//# sourceMappingURL=Radio.js.map